module.exports = __webpack_public_path__ + "img/rampchart.d39bcd91.png";